import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { DettaglioDateDataSource } from 'src/app/services/dettaglio-date.datasource';
import { EventiSegnalazioniDataSource } from 'src/app/services/eventi-segnalazioni.datasource';
import { TemplateService } from 'src/app/services/template.service';
import { DatePipe } from '@angular/common';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { tap } from 'rxjs/operators';
import { merge } from 'rxjs';
import { AclTipo } from 'src/app/model/AclTipo.enum';
import { EventiService } from 'src/app/services/eventi.service';

@Component({
  selector: 'app-dettaglio-date',
  templateUrl: './dettaglio-date.component.html',
  styleUrls: ['./dettaglio-date.component.css']
})

export class DettaglioDateComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  displayedColumns: string[] = [
    "enteAssociato",
    "descrizione",
    "dataChiusuraRaccoltaDati",
    "dataChiusuraCorrezioneDati",
  ];

  dataSource: DettaglioDateDataSource;
  risultatiPerPagina: number = 5;
  nodeCode: String;
  nodeCodeChecker: boolean;
  dateDTO: any;
  acl: String;
  nomeEvento: string = "";


  constructor(public dialogRef: MatDialogRef<DettaglioDateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModelEventiCalamitosi.DialogData,
    private templateService: TemplateService,
    private eventoService: EventiService,
    public datePipe: DatePipe) {
    this.dataSource = new DettaglioDateDataSource(this.templateService);
  }

  ngOnInit(): void {
    this.dataSource.loadDate(this.data.idEvento, "descrizione,ASC", 0, this.risultatiPerPagina);
    this.acl = sessionStorage.getItem("acl");
    if (this.acl === AclTipo.EELL) {
      this.displayedColumns = [
        "descrizione",
        "dataChiusuraRaccoltaDati",
        "dataChiusuraCorrezioneDati",
      ];
    }

    this.eventoService.getEvento(this.data.idEvento).subscribe(
      res => {
        this.nomeEvento = res.denominazione;
      }
    );

  }

  ngAfterViewInit() {
    
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

      merge(this.sort.sortChange, this.paginator.page)
        .pipe(
          tap(() => {
            this.dataSource.loadDate(this.data.idEvento, this.sort.active + "," + this.sort.direction, this.paginator.pageIndex, this.paginator.pageSize);
          }))
        .subscribe();

    this.dataSource.counter$
      .pipe(
        tap((count) => {
          this.paginator.length = count;
        })
      )
      .subscribe();
  }

}
